import React, { FC, useState } from 'react';
import { Field, useFormikContext } from 'formik';
import { styled } from 'linaria/react';
import { PaymentFormValues } from '@entities/payment';
import { withTheme } from '@shared/lib';
import { Checkbox, OldText } from '@shared/ui/atoms';
import DocumentLink from './DocumentLink';
import Tooltip from './Tooltip';
const CdekPersonalDataAgreementCheckbox: FC = () => {
  const {
    values,
    errors,
    setFieldValue
  } = useFormikContext<PaymentFormValues>();
  const [isChecked, setIsChecked] = useState(Boolean(values.isPersonalDataAgreed));
  const handleChange = () => {
    setFieldValue('isPersonalDataAgreed', !values.isPersonalDataAgreed);
    setIsChecked(prev => !prev);
  };
  return <Field name="isPersonalDataAgreed">
      {() => <FieldContentWrapper>
          <Checkbox name="isPersonalDataAgreed" size="xs" checked={isChecked} hasError={!!errors.isPersonalDataAgreed} onChange={handleChange} />
          <TooltipWrapper>
            <Tooltip open={!!errors.isPersonalDataAgreed && !isChecked}>Обязательный пункт</Tooltip>
          </TooltipWrapper>
          <OldText>
            Согласен с{' '}
            <DocumentLink target="_blank" href="https://multitransfer.ru/static/docs/public_offer.pdf">
              офертой оказания услуг
            </DocumentLink>{' '}
            и&nbsp;
            <DocumentLink target="_blank" href="https://mtcfinance.ru/documents/mtc_docs/about_us/company_docs/info_pnd.pdf">
              политикой обработки персональных данных
            </DocumentLink>
          </OldText>
        </FieldContentWrapper>}
    </Field>;
};
export default CdekPersonalDataAgreementCheckbox;
const _exp = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.xxs;
const _exp2 = /*#__PURE__*/() => ({
  theme
}) => theme.font.lineHeight.xxs;
const FieldContentWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "FieldContentWrapper",
  class: "f1thdqgi",
  propsAsIs: false,
  vars: {
    "f1thdqgi-0": [_exp(), "px"],
    "f1thdqgi-1": [_exp2(), "px"]
  }
}));
const TooltipWrapper = /*#__PURE__*/styled('div')({
  name: "TooltipWrapper",
  class: "t1kwhxsh",
  propsAsIs: false
});

require("./CdekPersonalDataAgreementCheckbox.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./CdekPersonalDataAgreementCheckbox.tsx");